import ikas from "../../providers/ikas";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  HeartIcon,
  MinusIcon,
  PlusIcon,
  TrashIcon,
  ShareNetwork,
} from "@phosphor-icons/react";
import config from "../../config";

export default function ProductDetail({ data, dataSetter }) {
  const location = useLocation();
  const productId = location.state?.id;
  const [product, setProduct] = useState(location.state);
  const [variants, setVariants] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [showCartModal, setShowCartModal] = useState(false);
  const [cartModalVisible, setCartModalVisible] = useState(false);

  const navigate = useNavigate();
  const onBackClick = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  useEffect(() => {
    if (!productId) return;
    async function getFullProduct() {
      const input = {
        productIdList: [productId],
        page: 1,
        perPage: 20,
      };
      const data = await ikas.searchProducts(input);
      const result = data?.results?.[0];
      if (result) {
        let productVariantsHashMap = {};
        result.variants.forEach((variant) => {
          let key = "";
          variant.variantValues.forEach((vv) => {
            key += vv.variantTypeId + vv.variantValueId + "/";
          });
          if (key.endsWith("/")) key = key.slice(0, -1);
          productVariantsHashMap[key] = { ...variant, key };
        });
        const firstVariantKey = Object.keys(productVariantsHashMap)[0];
        const firstVariant = productVariantsHashMap[firstVariantKey];
        setSelectedVariant(firstVariant);
        setProduct({ ...product, variantMap: productVariantsHashMap });
      }
    }
    getFullProduct();
  }, []);

  async function handleAddToCart() {
    setLoading(true);
    try {
      const cartId =
        localStorage.getItem("cartId") ?? sessionStorage.getItem("cartId");

      const input = {
        cartId,
        salesChannelId: config.SALES_CHANNEL_ID,
        storefrontThemeId: config.ROUTING_ID,
        item: {
          quantity: 1,
          variant: {
            id: selectedVariant.id,
            name: product.name,
          },
        },
      };

      const addResult = await ikas.addItemToCart(input);
      console.log(addResult);
      dataSetter(addResult);

      setShowCartModal(true);
      setTimeout(() => setCartModalVisible(true), 10); // animasyon için
    } catch (err) {
      setToast("Bir hata oluştu");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 1500);
    } finally {
      setLoading(false);
    }
  }
  // Handler for decrement button
  async function handleDecrement(id, cartQty) {
    setLoading(true);
    try {
      const cartId =
        localStorage.getItem("cartId") ?? sessionStorage.getItem("cartId");
      const input = {
        cartId,
        salesChannelId: config.SALES_CHANNEL_ID,
        storefrontThemeId: config.ROUTING_ID,
        item: {
          id,
          quantity: cartQty - 1,
          variant: {
            id: selectedVariant.id,
            name: product.name,
          },
        },
      };
      const updateResult = await ikas.addItemToCart(input);
      dataSetter(updateResult);
    } finally {
      setLoading(false);
    }
  }
  // Handler for increment button
  async function handleIncrement(id, cartQty) {
    if (cartQty) {
      setLoading(true);
      try {
        const cartId =
          localStorage.getItem("cartId") ?? sessionStorage.getItem("cartId");
        const input = {
          cartId,
          salesChannelId: config.SALES_CHANNEL_ID,
          storefrontThemeId: config.ROUTING_ID,
          item: {
            id,
            quantity: cartQty + 1,
            variant: {
              id: selectedVariant.id,
              name: product.name,
            },
          },
        };
        const updateResult = await ikas.addItemToCart(input);
        dataSetter(updateResult);
      } finally {
        setLoading(false);
      }
    }
  }
  const onWishlistIconClick = () => {
    let newFavorites = [...data.favorites];
    if (data?.favorites?.includes(product.id)) {
      newFavorites = data.favorites.filter((id) => id !== product.id);
    } else {
      newFavorites.push(product.id);
    }
    dataSetter({
      key: "favorites",
      value: newFavorites,
    });
    localStorage.setItem("favorites", JSON.stringify(newFavorites));
  };

  if (!product || !selectedVariant) return null;
  const isFavorite = data.favorites.includes(productId);
  const imageUrl = `https://cdn.myikas.com/images/${config.MERCHANT_ID}/${selectedVariant?.images?.[0]?.id}/image_540.webp`;
  const prices = selectedVariant?.prices?.[0]; //TODO:priceListId'ye göre seç
  const discount = prices?.discountPrice
    ? "%" +
      Number(
        ((prices?.sellPrice - prices?.discountPrice) / prices?.sellPrice) * 100
      ).toFixed(0) +
      " İNDİRİM"
    : "";

  const cartItem = [
    ...(data?.cart.orderLineItems ?? []),
    ...(data?.cart?.items ?? []),
  ].find((item) => {
    return item.variant.id === selectedVariant.id;
  });
  const cartQty = cartItem?.quantity || 0;

  // Rating: try product.rating or product.averageRating else 0
  const rating = product?.rating ?? product?.averageRating ?? 0;
  const roundedRating = Math.max(0, Math.min(5, Math.round(rating)));

  function renderStars(count) {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= count) {
        stars.push(
          <svg
            key={i}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-3 h-3 inline-block  text-yellow-500"
            aria-hidden
          >
            <path d="M12 .587l3.668 7.431L24 9.748l-6 5.847 1.417 8.264L12 18.896 4.583 23.859 6 15.596 0 9.748l8.332-1.73z" />
          </svg>
        );
      } else {
        stars.push(
          <svg
            key={i}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.5}
            className="w-3 h-3 inline-block m text-gray-400"
            aria-hidden
          >
            <path d="M12 .587l3.668 7.431L24 9.748l-6 5.847 1.417 8.264L12 18.896 4.583 23.859 6 15.596 0 9.748l8.332-1.73z" />
          </svg>
        );
      }
    }
    return stars;
  }
  return (
    <div
      style={{
        paddingTop: data?.system?.safeArea?.top,
      }}
      className="min-h-screen bg-white pb-24"
    >
      {/* Image */}
      <div className="w-full flex items-center justify-center border-b relative">
        <img
          src={imageUrl}
          alt={product.name}
          className="h-full object-contain w-full"
        />
        {/* Top bar görselin üstünde olacak şekilde absolute konumlandırıldı */}
        <div className="absolute top-0 left-0 right-0 flex justify-between p-4 z-20">
          <button
            onClick={onBackClick}
            className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow"
          >
            ←
          </button>
          <div className="flex gap-2">
            <button
              onClick={() => onWishlistIconClick()}
              className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow"
            >
              <HeartIcon
                color={isFavorite ? "#FF0000" : "#000000"}
                size={24}
                weight={isFavorite ? "fill" : "regular"}
              />
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 space-y-2">
        {/* Row: icons + name */}
        <div className="flex items-center justify-between">
          <div  className="flex flex-1 items-center justify-between gap-3">
            {/* Left icons: heart + share */}
           
            <h1 className="text-sm text-gray-700 font-medium">{product.name}</h1>
            <button
              onClick={() => {
                // basit paylaşma davranışı (navigator.share varsa kullan)
                if (navigator.share) {
                  navigator
                    .share({
                      title: product.name,
                      text: product.name,
                      url: window.location.href,
                    })
                    .catch(() => {});
                } else {
                  // fallback: kopyala
                  try {
                    navigator.clipboard.writeText(window.location.href);
                    setToast('Link kopyalandı');
                    setShowToast(true);
                    setTimeout(() => setShowToast(false), 1500);
                  } catch (e) {
                    // ignore
                  }
                }
              }}
              className="w-8 h-8 flex items-center justify-center"
              aria-label="Paylaş"
            >
              <ShareNetwork size={25} />
            </button>
          </div>
          {/* boşta kalan sağ alan - istenirse fiyat küçük gösterilebilir */}
        </div>

        {/* Rating + hr */}
        <div className="flex items-center gap-1">
          <div className="flex items-center">{renderStars(roundedRating)}</div>
          <div className="text-sm text-gray-500">{rating ? `${rating} / 5` : ""}</div>
        </div>
        <hr className="border-t border-gray-200 mt-1 mb-2" />

        {/* Variant types */}
        {product.productVariantTypes?.map(({ variantType }, index) =>
          variantType.values.length > 1 ? (
            <div key={index} className="mb-4">
              <h3 className="text-sm font-bold mb-2">{variantType.name}</h3>
              <div className="grid grid-cols-4 gap-3">
                {variantType.values.map((value) => {
                  const splittedSelectedVariantKey =
                    selectedVariant.key.split("/");
                  splittedSelectedVariantKey[index] = variantType.id + value.id;
                  let key = splittedSelectedVariantKey.join("/");

                  const variant = product.variantMap[key];
                  const variantStock = variant?.stocks?.reduce(
                    (totalValue, currentValue) => {
                      return totalValue + currentValue.stockCount;
                    },
                    0
                  );
                  const isSelected = selectedVariant.key === key;
                  const isAvailable =
                    variantStock > 0 || variant?.availableForSale;
                  return (
                    <div key={value.id} className="flex flex-col">
                      <button
                        onClick={() => {
                          if (isAvailable) setSelectedVariant(variant);
                        }}
                        disabled={!isAvailable}
                        className={`h-12 w-12 rounded text-sm font-medium transition-colors duration-200 border ${
                          isSelected
                            ? "bg-black text-white border-black"
                            : "bg-white text-black border-black hover:bg-gray-50"
                        } ${!isAvailable ? "opacity-50 cursor-not-allowed" : ""}`}
                      >
                        {value.name}
                      </button>
                      {/* Açıklama bölümü (varsa) */}
                      {value.description && (
                        <div className="mt-1 text-sm text-black">{value.description}</div>
                      )}
                    </div>
                  );
                })}
              </div>
              {/* Variant alt açıklaması: seçili varyantın kısa açıklaması */}
              <div className="mt-2 text-sm text-black">
                
                <iframe srcDoc={product.description} />
              </div>
            </div>
          ) : null
        )}

      
      </div>

      {/* Bottom bar (now fixed) */}
      <div className="fixed inset-x-0 bottom-0 border-t bg-white p-4 flex items-center justify-between z-20">
        <div>
          <div className="text-sm font-semibold">Toplam Tutar</div>
          {prices?.discountPrice && (
            <p className="line-through text-base font-bold text-black">
              ₺
              {parseFloat(prices?.sellPrice).toLocaleString("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          )}
          <p className="text-base font-bold text-black">
            ₺
            {parseFloat(
              prices?.discountPrice ?? prices?.sellPrice
            ).toLocaleString("tr-TR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </p>
        </div>
        {cartQty > 0 ? (
          <div className="flex items-center border border-black rounded-xl overflow-hidden min-w-[140px] h-12">
            <button
              className="w-12 h-12 bg-black flex items-center justify-center text-black text-xl border-none outline-none"
              onClick={() => {
                handleDecrement(cartItem.id, cartQty);
              }}
              disabled={loading}
            >
              {cartQty === 1 ? (
                <TrashIcon size={24} color="#fff" />
              ) : (
                <MinusIcon size={24} color="#fff" />
              )}
            </button>
            <span className="flex-1 text-center font-bold text-lg bg-black text-white h-12 flex items-center justify-center relative">
              <span>{cartQty}</span>
            </span>
            <button
              className="w-12 h-12 bg-black flex items-center justify-center text-white text-xl border-none outline-none"
              onClick={() => {
                handleIncrement(cartItem.id, cartQty);
              }}
              disabled={loading}
            >
              <PlusIcon size={24} color="#fff" />
            </button>
          </div>
        ) : (
          <button
            className="bg-black text-white px-6 py-2 rounded-lg text-base flex items-center justify-center min-w-[120px] h-10"
            onClick={handleAddToCart}
            disabled={loading}
          >
            {"Sepete Ekle"}
          </button>
        )}
      </div>
      {/* Toast & Loading Overlay */}
      {toast && (
        <div
          className={`fixed  left-1/2 transform -translate-x-1/2 z-[100] w-[95vw] max-w-xl bg-black text-white px-6 py-3 rounded-lg shadow-lg text-base font-semibold text-center transition-all duration-400
            ${
              showToast
                ? "opacity-100 translate-y-0"
                : "opacity-0 -translate-y-4 pointer-events-none"
            }
          `}
          style={{ minWidth: 320, top: data?.system?.safeArea?.top ?? 20 }}
        >
          {toast}
        </div>
      )}
      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
          <span className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></span>
        </div>
      )}
      {/* Sepete eklendi modalı - tam genişlikte, altta, animasyonlu, resim solda, içerik sağda, sağ üstte X butonu */}
      {showCartModal && (
        <div className="fixed inset-0 z-[200] flex flex-col justify-end bg-black bg-opacity-40">
          <div
            className={`w-full bg-white rounded-t-2xl shadow-lg py-6 px-4 flex flex-row items-center relative transition-all duration-300 ${
              cartModalVisible
                ? "translate-y-0 opacity-100"
                : "translate-y-full opacity-0"
            }`}
            style={{ minHeight: 160 }}
          >
            <button
              className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-black text-2xl"
              onClick={() => {
                setCartModalVisible(false);
                setTimeout(() => setShowCartModal(false), 300);
              }}
              aria-label="Kapat"
            >
              ×
            </button>
            <img
              src={imageUrl}
              alt={product.name}
              className="w-20 h-20 object-contain rounded mr-4 flex-shrink-0"
            />
            <div className="flex flex-col flex-1 items-start">
              <div className="text-green-600 font-bold text-lg mb-1">Product Added</div>
              <div className="font-semibold text-sm mb-3">
                {product.name}
                {selectedVariant.name &&
                  selectedVariant.name !== "Default Title" && (
                    <>
                      : {" "}
                      <span className="font-normal">{selectedVariant.name}</span>
                    </>
                  )}
              </div>
              <button
                className="w-full bg-black text-white py-2 rounded-lg font-bold mb-2"
                onClick={() => {
                  setCartModalVisible(false);
                  setTimeout(() => setShowCartModal(false), 300);
                  navigate("/cart");
                }}
              >
                Go to cart
              </button>
              <button
                className="w-full bg-gray-100 text-black py-2 rounded-lg font-semibold"
                onClick={() => {
                  setCartModalVisible(false);
                  setTimeout(() => setShowCartModal(false), 300);
                }}
              >
                Continue shopping
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
